import { getCompId, getUserRole } from "../Utility/service";
import { ADD_USER_API_SLUG, GENERATE_REFERRAL_CODE_API_SLUG, GET_ALL_USER_API_SLUG, GET_COMPANY_API_SLUG, GET_REFERRED_USER_SLUG, GET_SINGLE_USER_SLUG, GET_TEAMS_API_SLUG, TEAM_ASSIGN_API_SLUG, UPDATE_PREFERENCE_API_SLUG, USER_COMPANY_KNOWLEDGE_BASE_API_SLUG, USER_DELETE_API_SLUG, USER_REFERRED_LIST_SLUG, USER_UPDATE_API_SLUG } from "../constants/Api_constants";
import { axiosOpen, axiosSecureInstance } from "./axios";
import { USER_AC_TOKEN_UPDATE } from "../constants/Api_constants";
import { getUserID } from "../Utility/service";
const COMMON_ERROR_MESSAGE = "Something went wrong!";
const userId = getUserID();
export const updateUserCompanyKnowledgeBaseUseFlag = async (isUseCompanyKnowledgeBase) => {
    try {
        const response = await axiosSecureInstance.patch(USER_COMPANY_KNOWLEDGE_BASE_API_SLUG(userId), {
            isUseCompanyKnowledgeBase: isUseCompanyKnowledgeBase
        });
        return response;
    } catch (error) {
        console.log(error);
        return;
    }
}

export const getTeams = async () => {
    try {
        const response = await axiosSecureInstance.get(GET_TEAMS_API_SLUG());
        return response;
    } catch (error) {
        console.log(error);
        return;
    }
};

export const getCompany = async () => {
    try {
        const response = await axiosOpen.get(GET_COMPANY_API_SLUG(getCompId()));
        return response;
    } catch (error) {
        console.log(error);
        return;
    }
};

export const addUser = async (userData) => {
    let response = await axiosSecureInstance.post(ADD_USER_API_SLUG(), { ...userData });
    return response;
};

export const editUser = async (id, userData) => {
    try {
        let response = await axiosSecureInstance.patch(USER_UPDATE_API_SLUG(id), { ...userData });
        return response;
    } catch (err) {
        if (err && err.response.status === 400) {
            return err;
        }
    }
};

export const updateUserPreference = async (id, userData) => {
    try {
        let response = await axiosSecureInstance.patch(UPDATE_PREFERENCE_API_SLUG(id), { ...userData });
        return response;
    } catch (error) {
        const errorMessage = error?.response?.data?.message || COMMON_ERROR_MESSAGE;
        throw new Error(errorMessage);
    }
};

export const getUser = async (id) => {
    try {
        const response = await axiosSecureInstance.post(GET_SINGLE_USER_SLUG(),
            {
                userId: id
            }
        );
        return response;
    } catch (error) {
        console.log(error);
        return;
    }
};

export const getAllUsers = async (page, limit) => {
    try {
        const body = {
            compid: getCompId(),
            userRole: getUserRole(),
        };
        const response = await axiosSecureInstance.get(
            GET_ALL_USER_API_SLUG(page, limit, ""),
            body
        );
        return response;
    } catch (error) {
        console.log(error);
        return;
    }
};

export const deleteUser = async (userId) => {
    try {
        const response = await axiosSecureInstance.patch(USER_DELETE_API_SLUG(userId));
        return response;
    } catch (error) {
        console.log(error);
        return;
    }
};

export const searchUsers = async (page, limit, searchQuery) => {
    try {
        const body = {
            compid: getCompId(),
            userRole: getUserRole(),
        };
        const response = await axiosSecureInstance.get(
            GET_ALL_USER_API_SLUG(page, limit, searchQuery),
            body
        );
        return response;
    } catch (error) {
        console.log(error);
        return;
    }
};

export const assignTeam = async (teamData) => {
    try {
        const response = await axiosSecureInstance.patch(TEAM_ASSIGN_API_SLUG(), { ...teamData });
        return response;
    } catch (error) {
        console.log(error);
        return;
    }
};

export const updateUserAcToken = async (id, userData) => {
    try {
        let response = await axiosSecureInstance.patch(USER_AC_TOKEN_UPDATE(id), {...userData});
        return response;
    } catch (err) {
        if(err && err.response.status === 400 ){
            return err;
        }
    }
};

export const generateReferralCode = async (userId) => {
    try {
        const response = await axiosSecureInstance.put(GENERATE_REFERRAL_CODE_API_SLUG(), { userId: userId });
        return response;
    } catch (error) {
        console.log(error);
        return;
    }
};

export const getUsersReferedList = async (userId) => {
    try {
        const response = await axiosSecureInstance.get(USER_REFERRED_LIST_SLUG());
        return response;
    } catch (error) {
        console.log(error);
        return;
    }
};

export const getReferedUsers = async () => {
    try {
        const response = await axiosSecureInstance.get(GET_REFERRED_USER_SLUG());
        return response;
    } catch (error) {
        console.log(error);
        return;
    }
};

export const getUserOrg = async (id) => {
    try {
        const response = await axiosSecureInstance.post(GET_SINGLE_USER_SLUG(), {
            userId: id
        });
        if (response?.data?.user?.orgId) {
            return response.data.user.orgId;
        } else {
            console.error("orgId not found in response");
            return null;
        }
    } catch (error) {
        console.error("Error fetching user organization:", error);
        return null;
    }
};
